<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Deslocamento</h3>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoadAll"
            v-on:Reload="onLoadAll">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar PDF'" @click="onExport">
          <i class="fas fa-file-pdf text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn :IsText="true" :status="1" :value="moment(obj.dataDeslocamento).format('DD/MM/YYYY')" />
          <TableColumn :IsText="true" :status="1" :value="moment(obj.dataDeslocamento).format('HH:mm:ss')" />
          <TableColumn :IsText="true" :status="1" :value="obj.pessoaNome" />
          <TableColumn :IsText="true" :status="1" :value="obj.gerenteNome" />
          <TableColumn :is-text="true" :status="1" :value="!obj.coordsInicialTempoReal ? 'SIM':'NÃO'"/>
          <TableColumn :IsText="true" :status="1" :value="obj.kmRodadoFormatted" />
          <TableColumn :IsText="true" :status="1" :value="obj.valorReembolso" />
          <td class="text-center" v-b-tooltip.hover title="Abrir Mapa"><i @click="redirectToMaps(obj)" class="fas fa-map-marked-alt pointer"></i></td>

        </template>
      </tr>
    </Tables>
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import ReportVisitasRepository from '@/shared/http/repositories/deslocamento/report.js'
import SidebarSearch from '@/views/private/visitas/reports/deslocamento/search/SidebarVisitaDeslocamento.vue'

export default {
  name: 'ReportDeslocamento',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: [
        'Data',
        'Hora',
        'Cliente',
        'Gerente',
        'Localização Manual',
        'KM',
        'Valor Reembolso',
        'Mapa'
      ]
    }
  },
  components: {SidebarSearch},
  methods: {
    onLoad () {
      this.onShowSearch()
    },
    onLoadAll () {
      loading.push()
      ReportVisitasRepository.GetAllDeslocamento(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    async onExport () {
      loading.push()

      await ReportVisitasRepository.GetPdf(this.filters)
        .then((response) => {
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioDeslocamento.pdf'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)

      loading.close()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    redirectToMaps (obj) {
      const latitude = obj.latitudeCheckOutAnterior !== null ? obj.latitudeCheckOutAnterior : obj.latitudeInicial
      const longitude = obj.longitudeCheckOutAnterior !== null ? obj.longitudeCheckOutAnterior : obj.longitudeInicial

      const url = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${obj.latitudeFinal},${obj.longitudeFinal}`

      if (url) {
        window.open(url, '_blank').focus()
      } else {
        toast.error('O link de acesso não está disponível', 'Erro')
      }
    }

  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/deslocamento/ReportDeslocamento.vue